/**
 * Canonical grid selection shape (SEP 5.a §H).
 *
 * The `GridSelection` is the ONLY structure the purchase flow accepts.
 * It is intentionally decoupled from the existing viewer's cell/parcel
 * selection (which identifies EXISTING parcels via `selectedId`), so
 * the purchase preview never conflicts with the read-only parcel viewer.
 *
 * Coordinates are in canonical grid units (integers), matching the
 * on-chain `SaleV2.purchase(uint16 x, y, w, h, ...)` layout.
 */
export interface GridSelection {
  x: number;
  y: number;
  w: number;
  h: number;
}

/** Cheap frontend-only sanity check. NOT security — backend is authority. */
export function isValidGridSelection(sel: GridSelection): boolean {
  return (
    Number.isInteger(sel.x) &&
    Number.isInteger(sel.y) &&
    Number.isInteger(sel.w) &&
    Number.isInteger(sel.h) &&
    sel.x >= 0 &&
    sel.y >= 0 &&
    sel.w >= 1 &&
    sel.h >= 1
  );
}

/** Value equality — useful to detect stale quote state. */
export function selectionsEqual(
  a: GridSelection | null,
  b: GridSelection | null,
): boolean {
  if (a === null || b === null) return a === b;
  return a.x === b.x && a.y === b.y && a.w === b.w && a.h === b.h;
}
